module.exports = __webpack_public_path__ + "static/media/larv-min.f4c7107a.png";